const fetchApi = async (url, options) => {
  try {
    const response = await window.fetch(url, options);
    return await response.json();
  } catch (err) {
    console.error(`Header: error fetching initial data from ${url}: ${err}`);
    return {};
  }
};

const getYesterday = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date.toISOString().slice(0, 10);
};

const fetchFallbackCategories = async () => {
  const cacheFilename = `/header-ui-assets/cache/fallback-cache-${getYesterday()}.json`;
  const response = await fetchApi(cacheFilename);
  return response.child ? response : { child: [] };
};

const getInitialData = async isDesktop => {
  const stateUrl = '/header/api/state';
  const configUrl = '/header/api/config';

  const stateResponse = await fetchApi(stateUrl, {
    headers: { 'Cache-Control': 'no-cache' },
  });

  const queryParams =
    stateResponse?.headerClientConfigQueryParameters || '?navigationApi=true';

  const desktopParam = `&isdesktop=true`;
  const url = `${configUrl}${queryParams || ''}${
    isDesktop ? desktopParam : ''
  }`;

  const configResponse = await fetchApi(url);

  const categories =
    configResponse.categories || (await fetchFallbackCategories());

  return {
    ...configResponse,
    ...stateResponse,
    categories,
  };
};

export default getInitialData;
